import { ColumnConfig } from '../hooks/useTablePreferences';

export const clinicColumns: ColumnConfig[] = [
  {
    key: 'name',
    label: 'Clinic Name',
    defaultWidth: 200,
    minWidth: 150,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'idPrefix',
    label: 'ID Prefix',
    defaultWidth: 110,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'settings',
    label: 'Settings',
    defaultWidth: 160,
    minWidth: 130,
    visible: true,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'contact',
    label: 'Contact',
    defaultWidth: 180,
    minWidth: 140,
    visible: true,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'emailFooter',
    label: 'Email Footer',
    defaultWidth: 180,
    minWidth: 140,
    visible: true,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'smsFooter',
    label: 'SMS Footer',
    defaultWidth: 180,
    minWidth: 140,
    visible: true,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'createdAt',
    label: 'Created',
    defaultWidth: 130,
    minWidth: 110,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
];
